import { AlertTriangle } from "lucide-react"

import { Button } from "@/components/ui/button"

type TErrorFallbackProps = { resetError?: () => void }

export function ErrorFallback({ resetError }: TErrorFallbackProps) {
  return (
    <div className="flex h-screen w-full items-center justify-center p-6">
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        <AlertTriangle className="h-10 w-10 text-destructive" />
        <h1 className="text-xl font-semibold">Algo deu errado</h1>
        <p className="text-sm text-muted-foreground">
          Encontramos um erro inesperado. Tente recarregar a página. Se o
          problema persistir, entre em contato com o suporte.
        </p>
        <Button
          onClick={() => {
            resetError?.()
            window.location.reload()
          }}
        >
          Recarregar
        </Button>
      </div>
    </div>
  )
}
